/**
 * Quick view modal + quick add from product cards.
 */
(function () {
  var modal = document.querySelector("[data-quick-view-modal]");
  if (!modal) return;

  var body = modal.querySelector("[data-quick-view-body]");
  var closeEls = modal.querySelectorAll("[data-quick-view-close]");
  var loadingHtml = body ? body.innerHTML : "<p>Loading…</p>";

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function setLoading() {
    if (body) body.innerHTML = loadingHtml;
  }

  function openQuickView(handle) {
    if (!handle || !body) return;
    setLoading();
    openModal();

    fetch("/products/" + encodeURIComponent(handle) + "?section_id=quick-view-product")
      .then(function (res) {
        if (!res.ok) throw new Error("Quick view failed");
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var section = doc.querySelector(".shopify-section") || doc.body;
        body.innerHTML = section.innerHTML;
      })
      .catch(function () {
        body.innerHTML =
          '<p style="color: var(--color-muted);">Unable to load product. <a href="/products/' +
          encodeURIComponent(handle) +
          '">View product</a></p>';
      });
  }

  document.addEventListener("click", function (e) {
    var viewBtn = e.target.closest("button[data-quick-view]");
    if (viewBtn) {
      e.preventDefault();
      e.stopPropagation();
      openQuickView(viewBtn.getAttribute("data-quick-view"));
      return;
    }

    var addBtn = e.target.closest("[data-quick-add]");
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = addBtn.getAttribute("data-quick-add");
      if (!variantId) return;

      if (!window.WearableCart || typeof WearableCart.addToCart !== "function") {
        window.location.href = "/cart/add?id=" + encodeURIComponent(variantId);
        return;
      }

      addBtn.disabled = true;
      WearableCart.addToCart(variantId, 1)
        .catch(function () {
          window.location.href = "/cart/add?id=" + encodeURIComponent(variantId);
        })
        .finally(function () {
          addBtn.disabled = false;
        });
      return;
    }

    if (e.target.closest("[data-quick-view-close]")) {
      e.preventDefault();
      closeModal();
    }
  });

  closeEls.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      closeModal();
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });

  document.addEventListener("cart:updated", function () {
    if (modal.classList.contains("is-open")) closeModal();
  });
})();
